import type { ApiEndpoint } from '../../api/monitor';
import { Panel } from '../../components/ui/Card';
import { HEALTH_TONE, formatLatency } from '../../lib/health';

interface ApiListCardProps {
  apis: ApiEndpoint[];
  onSeeAll: () => void;
}

/**
 * Lista compacta das APIs cadastradas: se está ativa (isto é, se o cron a
 * verifica) e, quando está, como ela respondeu na última checagem. A tela de
 * Status mostra só as ativas; aqui as pausadas aparecem de propósito — uma API
 * fora do monitoramento é justamente o que passa despercebido.
 */
export function ApiListCard({ apis, onSeeAll }: ApiListCardProps) {
  return (
    <Panel title="APIs monitoradas" action={{ label: 'ver tudo', onClick: onSeeAll }}>
      {apis.length === 0 ? (
        <div className="text-ink-400 py-3 text-[12.5px]">
          Nenhuma API cadastrada. Cadastre as URLs em Administração.
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {apis.map((api) => {
            const tone = HEALTH_TONE[api.health.status];

            return (
              <div key={api.id} className="flex items-center gap-2 text-[13px]">
                <span
                  className={`size-2 shrink-0 rounded-full ${api.active ? tone.dot : 'bg-line-300'}`}
                  title={api.active ? tone.label : 'Inativa'}
                />
                <span className="min-w-0 flex-1 truncate font-semibold" title={api.name}>
                  {api.name}
                </span>
                <span
                  className={`rounded-full px-[7px] py-0.5 text-[10.5px] font-bold ${
                    api.active ? 'bg-surface-200 text-ink-600' : 'bg-surface-200 text-ink-400'
                  }`}
                >
                  {api.active ? 'Ativa' : 'Inativa'}
                </span>
                <span className="text-ink-400 w-14 shrink-0 text-right text-[11.5px]">
                  {api.active ? formatLatency(api.health.latencyMs) : '—'}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
